import { useTranslation } from "react-i18next"

import { Badge } from "@/components/ui/badge"
import { type SalesChannelEnum } from "@/enums"

interface OrdersSaleChannelBadgeProps {
  saleChannel: SalesChannelEnum
}
export const OrdersSaleChannelBadge = ({
  saleChannel,
}: OrdersSaleChannelBadgeProps) => {
  const { t } = useTranslation()

  const getSalesChannelName = (
    salesChannel?: SalesChannelEnum
  ): string => {
    if (!salesChannel)
      return t("common.noData") || "Indefinido"
    return (
      t(`orders.salesChannels.${salesChannel}` as const) ||
      salesChannel
    )
  }

  return (
    <Badge
      variant="none"
      className="flex h-fit items-center justify-start gap-1 rounded-full"
    >
      <div className="rounded-full bg-primary px-2 py-1 text-white">
        {getSalesChannelName(saleChannel)}
      </div>
    </Badge>
  )
}
